import React, { useContext, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import SecurityGroupAddModal from '@totem/components/users/container/actions/securityGroups/SecurityGroupAddModal';
import SecurityGroupsTable from '@totem/components/users/container/actions/securityGroups/SecurityGroupsTable';
import UserDetailsContext from '@totem/components/users/details/UserDetailsContext';
import { EligibleSecurityGroup } from '@totem/types/user';

const UserSecurityGroups = () => {
  const { userProfile } = useContext(UserProfileContext);
  const {
    user,
    securityGroups,
    securityGroupsLoading,
    eligibleGroups,
    orgHierarchy,
    onSecurityGroupAdd,
    onSecurityGroupRemove,
  } = useContext(UserDetailsContext);
  const [showAddGroup, setShowAddGroup] = useState<boolean>(false);

  const isAdmin =
    permissions.organizationalAdministrator.hasPermissions(userProfile);

  const handleAddGroupSubmit = (
    securityGroup: EligibleSecurityGroup,
    regionId: string,
    buildingId: string,
    controlSystemId: string,
  ) => {
    onSecurityGroupAdd({
      id: securityGroup.id,
      name: securityGroup.name,
      description: securityGroup.description,
      regionId,
      buildingId,
      controlSystemId,
    });

    setShowAddGroup(false);
  };

  return (
    <>
      <IBCard
        isCovered
        title="Security Groups"
        extra={
          isAdmin && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setShowAddGroup(true)}
            >
              Add Security Group
            </Button>
          )
        }
      >
        <SecurityGroupsTable
          loading={securityGroupsLoading}
          orgHierarchy={orgHierarchy}
          eligibleGroups={eligibleGroups}
          securityGroups={securityGroups}
          onRemoveGroup={onSecurityGroupRemove}
        />
      </IBCard>

      {showAddGroup && (
        <SecurityGroupAddModal
          user={user}
          orgHierarchy={orgHierarchy}
          eligibleGroups={eligibleGroups}
          visible={showAddGroup}
          onClose={() => setShowAddGroup(false)}
          onSubmit={handleAddGroupSubmit}
        />
      )}
    </>
  );
};

export default UserSecurityGroups;
